import * as qs from "querystring";
import * as t from "io-ts";
import { fetchJSON } from "./fetchJSON";
import { API_BASE_URL } from "../config";
const Tag = t.interface({
    // FIXME: drop the @ once it's safe to merge
    "@id": t.string,
    "@type": t.union([
        t.literal("Dimension"),
        t.literal("Topic"),
        // FIXME: Use real types
        t.literal("Location"),
        t.literal("Time")
    ]),
    label: t.string
}, "Tag");
const Tags = t.array(Tag, "Tags");
/**
 * Transform API response into a more type-able structure.
 * We're using (d: any) -> any because we validate the result.
 *
 * **BEWARE**: There's no defensive coding in here. If a property doesn't
 * exist in the response, the whole transformation will blow up! This could
 * probably be done in a safer way (everything as Maybe?) but for now, errors
 * have to be caught somewhere else.
 */
const transformTags = (tags) => {
    if (!tags.member) {
        return [];
    }
    return tags.member;
};
export const fetchTags = (params) => fetchJSON({
    url: `${API_BASE_URL}/tags/?${qs.stringify(params)}`,
    decode: data => {
        const transformed = transformTags(data);
        const decoded = Tags.decode(transformed);
        // console.log(PathReporter.report(decoded));
        return decoded;
    }
});
export const tagToParams = (t) => ({
    [t["@type"].toLowerCase()]: t["@id"]
});
export const tagsToParams = (tags) => tags.reduce((params, t) => {
    const k = t["@type"].toLowerCase(); // Huh?
    const p = params[k];
    params[k] = p ? p.concat(t["@id"]) : [t["@id"]];
    return params;
}, {});



// WEBPACK FOOTER //
// ./src/api/tags.ts